export const StickyNoteIcon = ({ color = 'currentColor', width = 24, height = 24 }: { color?: string; width?: number; height?: number }) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M13.3016 3.00142H6.00158C5.75118 2.98774 5.50552 3.07363 5.31819 3.24035C5.13086 3.40708 5.01705 3.64111 5.00158 3.89142V20.0014C4.97158 20.5214 5.37158 20.9714 5.89158 21.0014H17.8016C18.052 21.0151 18.2976 20.9292 18.485 20.7625C18.6723 20.5958 18.7861 20.3617 18.8016 20.1114V8.50142M13.3016 3.00142V8.50142H18.8016M13.3016 3.00142L16.0516 5.75142L18.8016 8.50142M8.90158 12.8014H14.9016M8.90158 16.6014H14.9016M10.0416 8.80142H8.90158'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
